<div class="header">
  <button
    pButton
    (click)="backButton()"
    class="back-button"
    severity="secondary"
    icon="ph ph-caret-left"
    aria-label="Back"></button>
  <dk-progress-bar [progressValues]="progressValues"></dk-progress-bar>
  <span class="title-text">{{ 'doktar_app.auth.register.create_password.title' | translate }}</span>
  <span class="subtitle-text">
    {{ 'doktar_app.auth.register.create_password.subtitle' | translate }}
  </span>
</div>

<span class="create-pwd-input-label">
  {{ 'doktar_app.common.password_label' | translate }}
</span>

<p-password
  class="password-input-container"
  [fluid]="true"
  inputStyleClass="password-input-text"
  name="password"
  [(ngModel)]="registerModal.password"
  #passwordInput="ngModel"
  [placeholder]="'doktar_app.auth.register.create_password.password_placeholder' | translate"
  (onFocus)="passwordFocused = true"
  (onBlur)="onPasswordBlur()"
  feedback="false"
  [toggleMask]="true">
  <ng-template pTemplate="showicon">
    <span class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon">{{
      'Show'
    }}</span>
  </ng-template>
  <ng-template pTemplate="hideicon">
    <span class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon">{{
      'Hide'
    }}</span>
  </ng-template>
</p-password>
<div
  class="password-info-container"
  *ngIf="passwordFocused || (registerModal.password && !passwordFocused && !isPasswordValid)">
  <span *ngIf="passwordFocused" class="password-info-text">
    {{ 'doktar_app.auth.register.create_password.password_hint' | translate }}
  </span>
  <span *ngIf="registerModal.password && !passwordFocused && !isPasswordValid" class="password-invalid-text">
    @for (error of passwordValidationErrors; track error) {
      {{ '• ' + error }}<br />
    }
  </span>
</div>

<span class="confirm-pwd-input-label">
  {{ 'doktar_app.auth.register.create_password.repeat_password' | translate }}
</span>
<p-password
  class="password-input-container"
  [fluid]="true"
  inputStyleClass="confirm-password-input-text"
  [ngClass]="{
    'error-border': registerModal.password && confirmPassword && !doPasswordsMatch,
  }"
  name="confirmPassword"
  [(ngModel)]="confirmPassword"
  #confirmPasswordInput="ngModel"
  [placeholder]="'doktar_app.auth.register.create_password.repeat_password_placeholder' | translate"
  (onBlur)="onConfirmPasswordBlur()"
  feedback="false"
  [toggleMask]="registerModal.password && isPasswordValid ? true : false"
  [disabled]="!isPasswordValid">
  <ng-template pTemplate="showicon">
    <span class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon">{{
      'Show'
    }}</span>
  </ng-template>
  <ng-template pTemplate="hideicon">
    <span class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon">{{
      'Hide'
    }}</span>
  </ng-template>
</p-password>
<div class="create-pwd-buttons">
  <dk-button
    class="continue-button"
    [size]="'xlarge'"
    [label]="'doktar_app.common.continue' | translate"
    [disabled]="
      !registerModal.password ||
      !confirmPassword ||
      passwordInput.invalid ||
      confirmPasswordInput.invalid ||
      !doPasswordsMatch ||
      !isPasswordValid
    "
    (onClick)="continueCreatePwdStep()"></dk-button>
</div>
